import WebFont from 'webfontloader';

WebFont.load({
    custom: {
        families: ['Intro Inline:n4'],
        urls: ['./css/fonts.css']
    },
    google: {
        families: ['Open Sans:400,700:cyrillic']
    }
});


// WEBPACK FOOTER //
// ./js/fonts.js